import { ThemeProvider } from "@mui/material"
import GlobalStyles from "./components/GlobalStyles"
import default_theme from "./theme/index"
import ProtectedRoutes from "./ProtectedRoutes"
import React, { useEffect } from "react"
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { logout } from "./actions/auth"
import { useDispatch, useSelector } from "react-redux"
import store from "./store"
import { useTranslation } from "react-i18next"
import * as Util from "./services/global.service"

import MessageDialog from "./components/inbox/MessageDialog"

const App = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isError = useSelector((state) => state.checkApi)
  const Start = useSelector((state) => state.Start)

  const [errorDialog, setErrorDialog] = React.useState(false)

  const handleErrorDialog = (value) => {
    setErrorDialog(value)
  }

  useEffect(() => {
    console.log("iserror", isError)
    if (isError?.error === "401" || isError?.error === 401) {
      if (isError?.message?.code === "token.msg.access_denied" || isError?.message?.code === "Token not found" || isError?.message === "token.msg.access_denied" || isError?.message === "Token not found") {
        dispatch(logout()).then(
          (response) => {
            localStorage.removeItem('date');
            localStorage.removeItem('user');
            localStorage.removeItem("proxy");
            localStorage.setItem("error", JSON.stringify(isError));
            let pathTologin = response?.data?.data?.url
            if (Util.formatData(pathTologin, false) !== false) {
              const newWindow = window.open(pathTologin, '_self', 'noopener,noreferrer')
              if (newWindow) newWindow.opener = null
            } else {
              console.log('Navigate', 1);
              //navigate('/' + localStorage.getItem("site"), { replace: false });
              window.location.href = '/' + localStorage.getItem("site")
            }
          }
        ).catch((err) => {
          localStorage.removeItem('date');
          localStorage.removeItem('user');
          localStorage.removeItem("proxy");
          localStorage.setItem("error", JSON.stringify(isError));
          console.log('Navigate', 2);
          //navigate('/' + localStorage.getItem("site"), { replace: false });
          window.location.href = '/' + localStorage.getItem("site")
        })
        store.dispatch({
          type: "ERROR",
          payload: null,
        })
      }
    } else {
      if (isError !== undefined && isError !== null && Object.keys(isError).length > 0) {
        handleErrorDialog(true)
      }
    }
  }, [isError])

  // global error scroll when SET `SCROLL_TO_ERROR` to `true`
  useEffect(() => {
    if (Start.scrollToError) {
      const element = document.getElementsByClassName('Mui-error')?.[0]
      if (element) {
        // scroll to first found element
        element.scrollIntoView({ behavior: 'smooth' })
      }
      store.dispatch({
        type: "SCROLL_TO_ERROR",
        payload: false,
      })
    }
  }, [Start.scrollToError])


  return (
    <ThemeProvider theme={default_theme}>
      <GlobalStyles />
      <MessageDialog open={errorDialog} setValue={handleErrorDialog} type="fail" title={t("label.error")} text={t("label.errorText")} />
      <ProtectedRoutes />
    </ThemeProvider>
  )
}

export default App

/* TODO Sprint 1
 *   Sign In
 *     - Sign In
 *     - Forget Password
 *     - Consent
 *   Home & Menu
 *   Employee PA Planning
 *     - Sellect rubric
 *     - Plan Version
 *     - Submit to Approve
 *   Work Experience (Portfolio)
 *     - Integration
 *     - Key in
 *   My Request & My Inbox
 *
 * */
